const state = {
    loadScreenModalShow : false,
    loadScreenModalShowTime : 900,
    loadScreenMsg :["請", "稍", "後", ".", ".", ".", ".", ".", "."],
    loadScreenMsgProgressValue:0,
    loadScreenMsgProgressShow:false
}
const getters = {
    get_loadScreenModalShow: state =>  {
        return state.loadScreenModalShow
    },
    get_loadScreenMsg: state =>  {
        return state.loadScreenMsg
    },
    get_loadScreenMsgProgressValue: state =>  {
        return state.loadScreenMsgProgressValue
    },
    get_loadScreenMsgProgressShow: state =>  {
        return state.loadScreenMsgProgressShow
    },
}
const actions = {
    show_loadScreenModal(context) {
        context.commit('SHOW_LOADSCREENMODAL');
    },
    hide_loadScreenModal(context) {
        context.commit('HIDE_LOADSCREENMODAL');
    },
    trigger_loadScreenModal(context) {
        context.commit('TRIGGER_LOADSCREENMODAL');
    },
    set_loadScreenMsg(context,msg) {
        context.commit('SET_LOADSCREENMSG',msg);
    },
    set_loadScreenMsgProgressValue(context) {
        context.commit('SET_LOADSCREENMSGPROGRESSVALUE');
    },
    show_loadScreenMsgProgress(context) {
        context.commit('SHOW_LOADSCREENMSGPROGRESS');
    },
}
const mutations = {
    SHOW_LOADSCREENMODAL(state) {
        state.loadScreenModalShow = true;
    },
    HIDE_LOADSCREENMODAL(state) {
        state.loadScreenModalShow = false;
    },
    TRIGGER_LOADSCREENMODAL(state) {
        state.loadScreenModalShow = !state.loadScreenModalShow;
    },
    SET_LOADSCREENMSG(state, msg) {
        state.loadScreenMsg = msg.split('');
    },
    SET_LOADSCREENMSGPROGRESSVALUE(state) {
        for(var i =1;i<6;i++){
            (function(i) {
                setTimeout(function() {
                    state.loadScreenMsgProgressValue = i*20;
                }, (i + 1) * 500);
            })(i)
        }
        setTimeout(function() {
            state.loadScreenModalShow = false;
            state.loadScreenMsgProgressShow = false;
            state.loadScreenMsgProgressValue = 0;
        },3900)
    },
    SHOW_LOADSCREENMSGPROGRESS(state) {
        state.loadScreenMsgProgressShow = true;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/loadScreenModal.js